import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/onDemandRevenueSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const SourceCategory = () => {
  const dispatch = useDispatch();
  const category_sources = useSelector((state) => state.onDemandRevenue.filters.category_sources);
  const sourceCategory = useSelector(
    (state) => state.onDemandRevenue.selectedFilters.sourceCategory
  );

  const handleUpdateCategory = (data) => {
    dispatch(actionCreators.updateSourceFilter(data));
  };

  return (
    <MultiSelectDropdown
      options={category_sources}
      selectedFilters={sourceCategory}
      includeFilter
      enableOnly
      height={324}
      includeSelectAll
      numberDisplayed={0}
      onSelectChange={handleUpdateCategory}
    />
  );
};

export default SourceCategory;
